import './assets/main.css';
import '/node_modules/primeflex/primeflex.css';
import 'primeicons/primeicons.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';

import ConfirmationService from 'primevue/confirmationservice';

const app = createApp(App);
app.use(PrimeVue, {
    theme: { preset: Aura, options: { darkMode: false, darkModeSelector: '.is-dark-mode' } },
    options: {
        darkModeSelector: false,
    },
    ripple: true,
});

app.use(createPinia());
app.use(router);

app.use(ConfirmationService);

app.mount('#app');
